import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter, map } from 'rxjs';

interface ManualHeaderState {
  backLink: string | null;
  title: string;
}

@Component({
  selector: 'app-manual-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './manual-layout.component.html',
  styleUrl: './manual-layout.component.css',
})
export class ManualLayoutComponent {
  private readonly router = inject(Router);

  readonly header = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => this.resolveHeader(e.urlAfterRedirects)),
    ),
    { initialValue: this.resolveHeader(this.router.url) },
  );

  goBack(): void {
    const link = this.header().backLink;
    if (link) this.router.navigateByUrl(link);
  }

  /** /manual → logo only · sub pages → back to the parent level + title */
  private resolveHeader(url: string): ManualHeaderState {
    const parts = url.split(/[?#]/)[0].split('/').filter(Boolean);
    if (parts[0] !== 'manual' || parts.length === 1) {
      return { backLink: null, title: '' };
    }

    const section = parts[1];
    if (section === 'guides') {
      const kind = parts[2] === 'ev' ? 'ev' : 'parking';
      const title = kind === 'ev' ? 'คู่มือ EV Charger' : 'คู่มือ Parking';
      return parts.length > 3
        ? { backLink: `/manual/guides/${kind}`, title }
        : { backLink: '/manual', title };
    }
    if (section === 'report') return { backLink: '/manual', title: 'แจ้งปัญหา' };
    if (section === 'member-qr') return { backLink: '/manual', title: 'Member QR' };
    return { backLink: '/manual', title: 'ศูนย์ช่วยเหลือ' };
  }
}
